// src/components/ClientPortalDashboard.js

import React from 'react';
import 'animate.css';

function ClientPortalDashboard({ currentUser, clients, cases, documents, invoices, tasks, communicationLogs }) {
  // Find the specific client profile linked to the current user
  const clientProfile = (clients || []).find(client => client.user === currentUser.id);

  // Filter data relevant to this specific client profile
  const clientCases = (cases || []).filter(c => c.client === (clientProfile ? clientProfile.id : null));
  const clientDocuments = (documents || []).filter(d => d.client === (clientProfile ? clientProfile.id : null));
  const clientInvoices = (invoices || []).filter(i => i.client === (clientProfile ? clientProfile.id : null));
  const clientTasks = (tasks || []).filter(t => t.case && (clientCases || []).some(c => c.id === t.case)); // Tasks related to client's cases
  // eslint-disable-next-line no-unused-vars
  const clientCommunicationLogs = (communicationLogs || []).filter(log => log.client === (clientProfile ? clientProfile.id : null) || (log.case && (clientCases || []).some(c => c.id === log.case)));

  // Basic stats for the client dashboard
  const totalCases = clientCases.length;
  const openCases = clientCases.filter(c => c.status === 'OPEN' || c.status === 'ACTIVE').length;
  const totalDocuments = clientDocuments.length;
  const outstandingInvoices = clientInvoices.filter(i => i.status !== 'PAID' && i.status !== 'CANCELLED').length;
  const pendingTasks = clientTasks.filter(t => t.status === 'PENDING' || t.status === 'IN_PROGRESS').length;

  return (
    <div className="client-portal-dashboard animate__animated animate__fadeInUp">
      <h2 className="mb-4 text-primary">Welcome, {currentUser.username}!</h2>
      {clientProfile ? (
        <p className="lead text-secondary">Your Client Profile: {clientProfile.first_name} {clientProfile.last_name}</p>
      ) : (
        <p className="lead text-warning">Your user account is not yet linked to a client profile. Please contact the firm administrator.</p>
      )}

      <h3 className="my-4 text-secondary">Your Overview</h3>
      <div className="row">
        <div className="col-md-4 mb-4">
          <div className="card text-white bg-primary h-100 rounded-lg shadow-md">
            <div className="card-body">
              <h5 className="card-title"><i className="bi bi-folder me-2"></i> Your Cases</h5>
              <p className="card-text fs-3">{totalCases} Total ({openCases} Open)</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card text-white bg-success h-100 rounded-lg shadow-md">
            <div className="card-body">
              <h5 className="card-title"><i className="bi bi-file-earmark-text me-2"></i> Your Documents</h5>
              <p className="card-text fs-3">{totalDocuments}</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card text-white bg-info h-100 rounded-lg shadow-md">
            <div className="card-body">
              <h5 className="card-title"><i className="bi bi-currency-dollar me-2"></i> Outstanding Invoices</h5>
              <p className="card-text fs-3">{outstandingInvoices}</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card text-white bg-warning h-100 rounded-lg shadow-md">
            <div className="card-body">
              <h5 className="card-title"><i className="bi bi-check2-square me-2"></i> Pending Tasks</h5>
              <p className="card-text fs-3">{pendingTasks}</p>
            </div>
          </div>
        </div>
      </div>

      <h3 className="my-4 text-secondary">Recent Activity</h3>
      <div className="card rounded-lg shadow-md p-3 recent-activity-card">
        <p className="text-muted">This section will show recent updates related to your cases, documents, and communications.</p>
        {/* You could add a filtered list of recent communication logs or document uploads here */}
      </div>
    </div>
  );
}

export default ClientPortalDashboard;
